// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from '@/menu-items';

// подтвержденный пользователь
import { useAuth } from '@/auth/AuthContext';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { isVerified, hasVek, role } = useAuth();
  const navGroups = menuItem.items
    .filter((elem) => !(elem.restricted && !isVerified))
    .filter((elem) => !(elem.requiresVek && !hasVek))
    .filter((elem) => !(elem.id === 'admin' && role !== 'ADMIN'))
    .map((item) => {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />;
        default:
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Fix - Navigation Group
            </Typography>
          );
      }
  });
  return <Box>{navGroups}</Box>;
}
